/**
 * @file FontPartLine.tsx
 * @description Строка подсказки о шрифте: «Аа Шрифт заголовков · Montserrat»
 * и пометки под ней — начертание и регистр заголовков, «нет русских букв»
 * (phase19.16, приёмка Р2а, §7.17 п. 3; uiux-fonts-usage §4, §6). Длинное
 * название переносится, «Аа» остаётся слева.
 */

import type { SiteFontRegistry, SiteTheme } from "@chaiberi/shared";

import { Skeleton } from "../../../ui/skeleton";
import { FontGlyph } from "./FontGlyph";
import { fontLineLabel, fontLineName, headingStyleNote, sampleWeight, type FontNoteLine } from "../../../../lib/site-builder/element-font-lines";

export const NO_CYRILLIC_TEXT = "⚠ В шрифте нет русских букв — русский текст покажется запасным шрифтом";

interface Props {
  line: FontNoteLine;
  theme: SiteTheme;
  registry: SiteFontRegistry;
  /** Показать начертание и регистр (одна строка с шрифтом заголовков). */
  withStyle: boolean;
}

export function FontPartLine({ line, theme, registry, withStyle }: Props) {
  const name = fontLineName(line);
  const style = withStyle ? headingStyleNote(line, theme, registry) : null;
  return (
    <li className="flex min-w-0 items-start gap-2">
      <FontGlyph fontKey={line.key} weight={sampleWeight(line, theme)} />
      <span className="flex min-w-0 flex-col">
        <span className="break-words text-on-surface">
          {fontLineLabel(line, theme)}
          {name ? ` · ${name}` : null}
          {line.pending ? (
            <>
              {" · "}
              <Skeleton className="inline-block h-3 w-20 rounded bg-on-surface/10 align-middle" aria-label="Название загружается" />
            </>
          ) : null}
        </span>
        {style ? <span>{style}</span> : null}
        {line.noCyrillic ? <span className="text-warning">{NO_CYRILLIC_TEXT}</span> : null}
      </span>
    </li>
  );
}
